module.exports = __webpack_public_path__ + "static/media/mail-envelope-open.9ce7bc02.svg";